"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _QuestionName = require("./QuestionName");

var _QuestionName2 = _interopRequireDefault(_QuestionName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ["question", "unique", "value", "name"],

  components: {
    QuestionName: _QuestionName2.default
  },

  data: function data() {
    return {
      selected: this.value
    };
  },


  watch: {
    selected: function selected(value) {
      this.$emit("update", this.question.unique, value);
    }
  },

  computed: {
    range: function range() {
      var arr = [];

      for (var i = parseInt(this.question.to); i >= parseInt(this.question.from); i--) {
        arr.push(i);
      }

      return arr.reverse();
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/forms/elements/Range.vue
// module id = kGLl
// module chunks = 0 1